import SodRiskPriorityChip, {
  normalizeRiskPriority,
} from './SodRiskPriorityChip';

export default SodRiskPriorityChip;
export { normalizeRiskPriority };
